<template>
    <div>
        <el-tree :data="menuData"
                 :props="defaultProps"
                 show-checkbox
                 node-key="columnId"
                 @node-click="handleNodeClick">

            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                    <el-button v-if="data.columnLevel===0" type="text" size="mini" @click="() => append(data)">Append</el-button>
                    <el-button type="text" size="mini" @click="() => append(data)">Edit</el-button>
                    <el-button v-if="data.columnLevel>0" type="text" size="mini" @click="() => remove(node, data)">Delete</el-button>
                </span>
            </span>
        </el-tree>
    </div>
</template>

<script>
    import axios from 'axios';
    import id from "element-ui/src/locale/lang/id";
    export default {
        name: "Index",
        data() {
            return {
                menuData: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                }
            };
        },
        methods: {
            handleNodeClick(data) {
                console.log(data);
            },
            get(){
                axios({
                    method: 'get',
                    url: 'http://localhost:9002/system/column/tree/list',
                    // data: {
                    //
                    // }
                })
                .then((response) => {
                    this.menuData = response.data.data;
                    console.log(response.data.data);
                    // console.log("menuData"+menuData);
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            append(data) {
                const newChild = { id: id++, label: 'testtest', children: [] };
                if (!data.children) {
                    this.$set(data, 'children', []);
                }
                data.children.push(newChild);
            },

            remove(node, data) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
            },
        },
        created(){
            this.get()
        }
    }
</script>

<style scoped>

</style>
